<template>
  <div id="course-rank">
    <el-row>
      <el-col>
        <div class="page-title-box flex-between">
          <h4 class="page-title">最近学期课程</h4>
          <div class="page-title date-range">统计范围：{{ rankData.time }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row class="mb-3" :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="flex-between flex-align-item mb-3">
            <div class="chart-title">活跃度排行</div>
            <div><span class="operative" @click="viewActiveRank">查看更多&gt;&gt;</span></div>
          </div>
          <!-- <div class="chart-y">活跃度</div> -->
          <div id="active-charts" :style="{ height: '400px' }"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="flex-between flex-align-item mb-3">
            <div class="chart-title">课程发布排行</div>
            <div><span class="operative" @click="viewPublishRank">查看更多&gt;&gt;</span></div>
          </div>
          <!-- <div class="chart-y">活动数</div> -->
          <div id="publish-charts" :style="{ height: '400px' }"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="flex-between flex-align-item mb-3">
            <div class="chart-title">课程资源排行</div>
            <div><span class="operative" @click="viewResourceRank">查看更多&gt;&gt;</span></div>
          </div>
          <!-- <div class="chart-y">资源数</div> -->
          <div id="resource-charts" :style="{ height: '400px' }"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="flex-between flex-align-item mb-3">
            <div class="chart-title">课程讨论排行</div>
            <div><span class="operative" @click="viewDiscussRank">查看更多&gt;&gt;</span></div>
          </div>
          <!-- <div class="chart-y">讨论数</div> -->
          <div id="discuss-charts" :style="{ height: '400px' }"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rankData: [],
      activeData: [],
      publishData: [],
      resourceData: [],
      discussData: [],
      activeChart: null,
      publishChart: null,
      resourceChart: null,
      discussChart: null,
      screenWidth: '',
      screenHeight: '',
    }
  },
  computed: {
    // 4个图表对应X轴Y轴数据
    activeChartData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.activeData) {
        x.push(i.shortname)
        y.push(i.rank_num)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    publishChartData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.publishData) {
        x.push(i.shortname)
        y.push(i.rank_num)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    resourceChartData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.resourceData) {
        x.push(i.shortname)
        y.push(i.rank_num)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    discussChartData() {
      let x = []
      let y = []
      let data = {}
      for (let i of this.discussData) {
        x.push(i.shortname)
        y.push(i.rank_num)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
  },
  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  mounted() {
    this.getCourseRankApi()
    this.screenWidth = document.body.clientWidth //监听页面缩放
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
  },
  methods: {
    // 课程排行数据接口
    async getCourseRankApi() {
      await this.$store
        .dispatch('course/getCourseRank', {
          type: 'chart',
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.rankData = res.data
            this.activeData = res.data.activity
            this.publishData = res.data.publish
            this.resourceData = res.data.resource
            this.discussData = res.data.forum
            this.$store.commit('course/setCourseRank', res.data)
            this.iniActiveChart(this.activeChartData)
            this.iniPublishChart(this.publishChartData)
            this.iniResourceChart(this.resourceChartData)
            this.iniDiscussChart(this.discussChartData)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 图表初始化
    // 活跃度图表
    iniActiveChart(data) {
      var acChart = this.$echarts.init(document.getElementById('active-charts'))
      var acOption = {
        grid: {
          bottom: 90,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: data.x.length <= 10 ? 0 : Math.floor(data.x.length / 10),
            rotate: 30, //x轴文字倾斜
            padding: [0, -30, 0, 30], //文字左右定位
            margin: [40],
            formatter: function (value) {
              let rowMAx = 10
              let overValue = ''
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += '\n'
                  overValue += value[i]
                } else {
                  overValue += value[i]
                }
              }
              return overValue
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '活跃度',
          nameTextStyle: {
            color: '#98a6ad',
            fontSize: '14',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#3283F6',
            },
          },
        ],
      }
      acChart.setOption(acOption)
      this.activeChart = acChart
    },
    // 课程发布图表
    iniPublishChart(data) {
      var chart = this.$echarts.init(document.getElementById('publish-charts'))
      var option = {
        grid: {
          bottom: 90,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: data.x.length <= 10 ? 0 : Math.floor(data.x.length / 10),
            rotate: 30, //x轴文字倾斜
            padding: [0, -30, 0, 30], //文字左右定位
            margin: [40],
            formatter: function (value) {
              let rowMAx = 10
              let overValue = ''
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += '\n'
                  overValue += value[i]
                } else {
                  overValue += value[i]
                }
              }
              return overValue
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '活动数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            fontSize: '14',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#44CF9C',
            },
          },
        ],
      }
      chart.setOption(option)
      this.publishChart = chart
    },
    // 资源图表
    iniResourceChart(data) {
      var chart = this.$echarts.init(document.getElementById('resource-charts'))
      var option = {
        grid: {
          bottom: 90,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: data.x.length <= 10 ? 0 : Math.floor(data.x.length / 10),
            rotate: 30, //x轴文字倾斜
            padding: [0, -30, 0, 30], //文字左右定位
            margin: [40],
            formatter: function (value) {
              let rowMAx = 10
              let overValue = ''
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += '\n'
                  overValue += value[i]
                } else {
                  overValue += value[i]
                }
              }
              return overValue
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '资源数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            fontSize: '14',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#FCC015',
            },
          },
        ],
      }
      chart.setOption(option)
      this.resourceChart = chart
    },
    // 讨论图表
    iniDiscussChart(data) {
      var chart = this.$echarts.init(document.getElementById('discuss-charts'))
      var option = {
        grid: {
          bottom: 90,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: data.x.length <= 10 ? 0 : Math.floor(data.x.length / 10),
            rotate: 30, //x轴文字倾斜
            padding: [0, -30, 0, 30], //文字左右定位
            margin: [40],
            formatter: function (value) {
              let rowMAx = 10
              let overValue = ''
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += '\n'
                  overValue += value[i]
                } else {
                  overValue += value[i]
                }
              }
              return overValue
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '讨论数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            fontSize: '14',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#43BEE1',
            },
          },
        ],
      }
      chart.setOption(option)
      this.discussChart = chart
    },
    getReSize() {
      let chartArr = [this.activeChart, this.publishChart, this.resourceChart, this.discussChart]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
    // 查看更多跳转
    viewActiveRank() {
      this.$router.push({
        path: '/course/courseRank/activeRank',
      })
    },
    viewPublishRank() {
      this.$router.push({
        path: '/course/courseRank/publishRank',
      })
    },
    viewResourceRank() {
      this.$router.push({
        path: '/course/courseRank/resourceRank',
      })
    },
    viewDiscussRank() {
      this.$router.push({
        path: '/course/courseRank/discussRank',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
  .date-range {
    color: rgba(108, 117, 125, 1);
    font-size: 14px;
  }
}
.operative {
  color: #409eff;
  margin-right: 0;
  cursor: pointer;
}
.chart-title {
  font-size: 16px;
  font-weight: bold;
  color: #343a40;
}
.chart-y {
  padding-left: 10px;
  color: #98a6ad;
}
</style>
